<template>
    <el-dialog
        title="提示"
        :close-on-click-modal="false"
        :visible.sync="visible"
        width="800px"
        :before-close="handleClose">
        <div>
            <div>以下车辆复核状态=复核不通过，请参照不通过原因，重新维护信息再提交审批，审批通过后再启用。</div>
            <el-table border :data="list" style="width: 100%;margin-top: 10px;">
                <el-table-column show-overflow-tooltip prop="supplierCode" label="供应商编码" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="licensePlateNo" label="车牌号" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="reviewFailReason" label="复核不通过原因"></el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            list: [],
        }
    },
    methods: {
        init(list) {
            this.visible = true
            this.list = list
        },
        handleClose(){
            this.visible = false
        },
    },
}
</script>
